import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavItemComponent } from '../nav-item.component';
import { Router } from '@angular/router';
import { SettingsNavItemViewModel } from './settings-nav-item-view-model';

@Component({
  selector: 'app-settings-nav-item',
  templateUrl: './settings-nav-item.component.html',
  styleUrls: ['./settings-nav-item.component.scss', '../nav-item.component.scss'],
  providers: [SettingsNavItemViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SettingsNavItemComponent extends NavItemComponent {
  constructor(
    public override viewModel: SettingsNavItemViewModel,
    router: Router
  ) {
    super(viewModel, router);
  }
}
